<template>
  <div id="aboutUsPage" class="container-fluid">
    <v-main>
      <BackBar/>
      <div class="text-center font19px">
        <i class="fa-regular fa-circle-info fa-lg"></i>
        درباره ما
      </div>
      <div class="row">
        <div class="col-12">
          <div class=" bg-white rounded-lg p-3" v-html="content">
          </div>

        </div>
      </div>

    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";

export default {
  name: "AboutUs",
  metaInfo: {
    title: 'ایوان خانه- درباره ما',
  },
  components: {BackBar},
  data: () => ({
    content: null,
    showLoaderDialog: false,
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "Publicly/AboutUs", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let json = JSON.parse(result)
              this.content = json.Description
            }
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));

    }
  }

}
</script>

<style scoped>

</style>